// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { EcwidCustomer, EcwidProduct, EcwidOrder, EcwidCategory, AppConfig, Redirect, Coupon, Secret, Announcement, Communication, CommunicationTopic, SubscriptionPackage, SubscriptionAccess, TeacherProductsOrder, ReportingOrderProducts, ArchivedTeacherProductsOrder, ProductCategory, ProductTag, ProductContent, JustBoughtProduct, ProductSEO, ProductBundle, Product, Taxonomy, TeacherAssessmentTemplate, AssessmentTemplate, TeacherSubjectTemplate, SubjectTemplate, School, TeacherActivity, Term, Holiday, TeacherClassSubject, Subject, TeacherSchedule, ReportingTeacher, TeacherProfile, CognitiveLevelJSON, BiWeekJSON } = initSchema(schema);

export {
  EcwidCustomer,
  EcwidProduct,
  EcwidOrder,
  EcwidCategory,
  AppConfig,
  Redirect,
  Coupon,
  Secret,
  Announcement,
  Communication,
  CommunicationTopic,
  SubscriptionPackage,
  SubscriptionAccess,
  TeacherProductsOrder,
  ReportingOrderProducts,
  ArchivedTeacherProductsOrder,
  ProductCategory,
  ProductTag,
  ProductContent,
  JustBoughtProduct,
  ProductSEO,
  ProductBundle,
  Product,
  Taxonomy,
  TeacherAssessmentTemplate,
  AssessmentTemplate,
  TeacherSubjectTemplate,
  SubjectTemplate,
  School,
  TeacherActivity,
  Term,
  Holiday,
  TeacherClassSubject,
  Subject,
  TeacherSchedule,
  ReportingTeacher,
  TeacherProfile,
  CognitiveLevelJSON,
  BiWeekJSON
};